import { EthereumContractAddresses } from '@repo/types-client';

const _registry: Record<string, EthereumContractAddresses> = {
  mainnet: {
    doodles: '0x8a90CAb2b38dba80c64b7734e58Ee1dB38B8992e',
    spaceDoodles: '0x620b70123fB810F6C653DA7644b5dD0b6312e4D8',
    dooplicator: '0x466CFcD0525189b573E794F554b8A751279213Ac',
    dooplication: '0x36c3ec16da484240f74d05c0213186a3248e0e48',
    dooplicationMarketplace: '0xCdeF9b7949869CbEdDCaeB398445e5972D8f564C',
    genesisBox: '0xB75F09b4340aEb85Cd5F2Dd87d31751EDC11ed39',
    genesisOpener: '0x867F4f2C66907114b9cE0BCc17f2626CEc2a97d8',
    doodlesDrops: '0x92C26f1148152bd0f7DF8F27c4b209674b84544D',
    delegateCash: '0x00000000000076A84feF008CDAbe6409d2FE638B',
  },
  sepolia: {
    doodles: '0x2d575CB69fD0C599CC4FBE7f991576B013e5F322',
    spaceDoodles: '0xf23c0602889b5D4582190b8F9D327a7546371b8c',
    dooplicator: '0x117d6E3c85Be677BC06257F0C152920c7f10Cd2B',
    dooplication: '0x82Eab19a466629AaB6118b7662339F8B1858eC83',
    dooplicationMarketplace: '0x60e04aed45BdbB99C3F8fef5eaB0193e29Ac9fFB',
    genesisBox: '0xf4E1b3edf6C477020b179C59a79C0683fd65d581',
    genesisOpener: '0x2E6b19034AF25B3F12297Ce0AE8a396E9963Ae32',
    doodlesDrops: '0xDC8dc26fF47fc7D447baeC8dB3F9cb0fCcB55d7f',
    delegateCash: '0x00000000000076A84feF008CDAbe6409d2FE638B',
  },
};

let _selectedNetwork: EthereumContractAddresses;

switch (process.env.NEXT_PUBLIC_APP_ENV) {
  case 'production':
    _selectedNetwork = _registry.mainnet ?? ({} as EthereumContractAddresses);
    break;
  default:
    _selectedNetwork = _registry.sepolia ?? ({} as EthereumContractAddresses);
    break;
}

export const ethereumContractAddresses =
  _selectedNetwork as Readonly<EthereumContractAddresses>;
